import axios from 'axios';
import { getBasePath } from '@/lib/base-path';

// Configurar o baseURL do axios para incluir o basePath do Next.js ('' = raiz, evita '//')
const getBaseURL = () => getBasePath();

// Criar instância do axios com baseURL configurado
const axiosInstance = axios.create({
  baseURL: getBaseURL(),
});

export default axiosInstance;

